import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useT } from "@/i18n_extra2";

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 text-[#D4AF37]" fill="#D4AF37" strokeWidth={0} />
    ))}
  </div>
);

export const Reviews = () => {
  const t = useT();
  const r = t.reviews;
  return (
    <section className="relative py-28 sm:py-32 bg-[#FAF9F6] overflow-hidden" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-8 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#D4AF37]">{r.label}</span>
            </div>
            <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05]">{r.title}</h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="flex items-center gap-4 shrink-0"
            data-testid="reviews-aggregate"
          >
            <span className="font-display font-bold text-6xl text-[#D4AF37] leading-none">{r.agg}</span>
            <span>
              <Stars />
              <span className="block mt-1.5 text-xs text-black/50">{r.aggOf} · {r.aggOn}</span>
            </span>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="reviews-strip">
          {r.items.map((rev, i) => (
            <motion.article
              key={rev.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              className="glass-panel rounded-2xl p-7 w-[320px] sm:w-[360px] shrink-0 snap-start flex flex-col hover:border-[#D4AF37]/40 transition-colors duration-500"
              data-testid={`review-card-${i}`}
            >
              <Stars />
              <p className="mt-5 text-sm text-black/70 leading-relaxed flex-1">“{rev.text}”</p>
              <div className="mt-6 pt-5 border-t border-black/10 flex items-center justify-between gap-3">
                <div>
                  <div className="font-display font-semibold text-sm">{rev.name}</div>
                  <div className="text-xs text-black/40 mt-0.5">{rev.when} · Google</div>
                </div>
                <span className="text-[10px] font-bold tracking-widest uppercase text-[#D4AF37] border border-[#D4AF37]/40 rounded-full px-3 py-1 whitespace-nowrap">
                  {rev.service}
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
